// src/api/mock/siloamStatusData.js

export const statusEmployeeData = [
  { id: "ya", name: "Ya" },
  { id: "tidak", name: "Tidak" },
];